
import React, { useState, useEffect } from 'react';
import { motion } from "framer-motion";
import { Skeleton } from "@/components/ui/skeleton";

interface MoviePosterProps {
  moviePoster: string;
  title: string;
}

export const MoviePoster: React.FC<MoviePosterProps> = ({ moviePoster, title }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);
  
  // Préchargez l'image pour une transition plus fluide
  useEffect(() => {
    const img = new Image();
    img.src = moviePoster;
    
    img.onload = () => {
      setIsLoaded(true);
    };
    
    img.onerror = () => {
      setIsError(true);
      setIsLoaded(true); // Marquer comme chargé même en cas d'erreur
    };
    
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [moviePoster]);
  
  return (
    <div className="flex justify-center lg:justify-end mt-4 lg:mt-0">
      <motion.div 
        className="relative w-full max-w-[320px] md:max-w-md" 
        initial={{ opacity: 0 }} 
        animate={{ opacity: 1 }} 
        transition={{ duration: 0.4, delay: 0.2 }}
      >
        <div className="absolute -inset-1.5 bg-gradient-to-r from-violet-500 to-purple-600 rounded-2xl blur opacity-30"></div>
        <div className="relative">
          {!isLoaded && (
            <Skeleton className="w-full h-[480px] rounded-2xl opacity-75" />
          )}
          
          <img 
            src={moviePoster} 
            alt={`Affiche du film ${title}`} 
            className={`rounded-2xl shadow-2xl object-cover w-full h-auto transition-opacity duration-300 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
            loading="eager"
            fetchPriority="high"
            decoding="async"
            onLoad={() => setIsLoaded(true)}
            onError={() => setIsError(true)}
            style={{ aspectRatio: '2/3' }}
          />
          
          {isError && (
            <div className="absolute inset-0 flex items-center justify-center bg-muted/20 rounded-2xl">
              <p className="text-muted-foreground text-sm">Image non disponible</p>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
};
